import reduce from 'lodash/reduce';

export const trimField = <T>(field: T): T =>
  typeof field === 'string' ? (field.trim() as T) : field;

export const trimObject = <T extends object>(object: T): T =>
  reduce(
    object,
    (memo, value, key) => {
      memo[key as keyof T] = trimField(value);
      return memo;
    },
    {} as T,
  );